import { useMemo } from "react";
import { getRandomArrayElement } from "./util";

// returns an id and an array of the valid interventions based on available word metadata
// requirements should be an object mapping versionId to required metadata
export default function useVersion(metadata, requirements) {
  return useMemo(getVersion, []);

  function getVersion() {
    const valid = [];
    for (const i in requirements) {
      const keys = requirements[i];
      if (objectContainsAllKeys(metadata, keys)) valid.push(i);
    }

    if (valid.length === 0) return { id: null, valid };

    const id = getRandomArrayElement(valid);
    return { id, valid };
  }
}

function objectContainsAllKeys(obj, keys) {
  for (const key of keys) {
    if (!(key in obj)) return false;
  }
  return true;
}
